import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

import { BORDERRADIUS as borderRadius } from "@fedsim/constants";

export const SpacedPaper = styled((props) => <Paper {...props}
  elevation={2} />)(
    ({ theme, dark = false, sx = {} }) => ({
      ...sx,
      padding: theme.spacing(.8),
      color: theme => dark && theme.palette.mode === "dark" ? '#999' : '#333',
      backgroundColor: dark && theme.palette.mode === "dark"
        ? "rgba(0, 0, 0, .5)" : theme.palette.mode === "dark" ? "rgba(0, 0, 0, .9)" :
          theme.palette.mode === "light" ? "rgba(25, 25, 25, 0.2)" : "rgba(255, 255, 255, .9)",
      borderRadius,
      backdropFilter: `blur(20px)`
      // height: "100%"
    })
  );

export default SpacedPaper;
